import { ReactNode } from 'react';

interface SurveyDetailProps {
  name: string;
  value: string | ReactNode;
}

const SurveyDetail = (props: SurveyDetailProps) => {
  const { name, value } = props;

  return (
    <div className="flex gap-2">
      <p className="font-raleway font-medium text-xs text-customGrey min-w-fit">{name}</p>
      <p className="flex gap-2 font-raleway font-medium text-xs relative">
        {value ? (value === 'true' ? 'Yes' : value === 'false' ? 'No' : value) : '-'}
      </p>
    </div>
  );
};

export default SurveyDetail;
